export default "__VITE_ASSET__BKHo8VMc__"